module.exports = __webpack_public_path__ + "img/9.1339fb46.jpg";